import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

// WhatsApp campaigns only send through the official API: Whatsapp::OneoffCampaignService#validate_provider! requires
// provider whatsapp_cloud and the Masifi::WhatsappCampaignCloudOnly gate rejects any other WhatsApp inbox. The native
// getter (inboxes/getWhatsAppInboxes) also lists QR and 360dialog inboxes, which can never send a campaign, so the
// campaign form (WhatsAppCampaignForm.vue, upstream: import + 1 line) reads this filtered list instead.
export const WHATSAPP_CLOUD_PROVIDER = 'whatsapp_cloud';

export const isCampaignWhatsAppInbox = inbox =>
  inbox?.provider === WHATSAPP_CLOUD_PROVIDER;

export const useMasifiCampaignWhatsAppInboxes = () => {
  const inboxes = useMapGetter('inboxes/getWhatsAppInboxes');
  return computed(() => (inboxes.value || []).filter(isCampaignWhatsAppInbox));
};
